
        import * as module0 from '$components/documentation/sidebar.css';import * as module1 from '$components/documentation/variables_table.css';import * as module2 from '$components/shared/navbar.css';import * as module3 from '$components/shared/navbar.js.rb'
        const modules = {
            "documentation/sidebar.css": module0,
            "documentation/variables_table.css": module1,
            "shared/navbar.css": module2,
            "shared/navbar.js.rb": module3,
        };
        export default modules;
      